/**
 * The variant registry — the single entry point Agent B (the card table) and
 * the integration layer consume. Every Solitaire variant is a `SolitaireVariant`
 * (see `types.ts`): a pure rules module built on the shared 52-card model.
 *
 * Add a variant by importing its module and listing it in `VARIANTS`.
 */
import { freecell } from './freecell';
import { klondike } from './klondike';
import { pyramid } from './pyramid';
import { spider } from './spider';
import { tripeaks } from './tripeaks';
import type { SolitaireVariant } from './types';

export { klondike } from './klondike';
export { freecell } from './freecell';
export { spider } from './spider';
export { pyramid } from './pyramid';
export { tripeaks } from './tripeaks';

/** id → variant. The renderer picks a variant by id and drives it generically. */
export const VARIANTS: Record<string, SolitaireVariant> = {
  [klondike.id]: klondike,
  [freecell.id]: freecell,
  [spider.id]: spider,
  [pyramid.id]: pyramid,
  [tripeaks.id]: tripeaks,
};

/** Ordered list for menus/pickers (registration order). */
export const VARIANT_LIST: SolitaireVariant[] = [klondike, freecell, spider, pyramid, tripeaks];

export type { SolitaireVariant } from './types';
